import { ApplicationUserService } from 'src/app/core/applicationuser.service';
import { ApplicationUsersDetailComponent } from './core/components/application-users/application-users-detail/application-users-detail.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularFireModule, FIREBASE_OPTIONS } from "@angular/fire/compat";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import { environment } from 'src/environments/environment';
import { MessagesModule } from 'primeng/messages';
import { MessageService } from 'primeng/api';
import { NotifierModule } from 'angular-notifier';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { PopoverModule } from 'ngx-smart-popover';
import { ApplicationUsersListComponent } from './core/components/application-users/application-users-list/application-users-list.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { AuthGuard } from './core/auth.gaurd';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideUserIdleConfig } from 'angular-user-idle';
import { TableModule } from 'primeng/table';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { initializeApp } from "firebase/app";
import { ReCaptchaEnterpriseProvider, provideAppCheck } from '@angular/fire/app-check';
import { getApp, provideFirebaseApp } from '@angular/fire/app';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { SidebarModule } from 'primeng/sidebar';
import { MenuModule } from 'primeng/menu';
import { PanelMenuModule } from 'primeng/panelmenu';
import { AuthInterceptor } from './core/auth.interceptor';
import { SdsSearchComponent } from './core/components/sds-search/sds-search.component';
import { DropdownModule } from 'primeng/dropdown';
import { LoginReportsComponent } from './core/components/activity-reports/login-reports/login-reports.component';
import { DownloadReportsComponent } from './core/components/activity-reports/download-reports/download-reports.component';
import { SearchSdsReportsComponent } from './core/components/activity-reports/search-sds-reports/search-sds-reports.component';
import { CalendarModule } from 'primeng/calendar';
import { DatePipe } from '@angular/common';
import { OverlayPanelModule } from 'primeng/overlaypanel';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ApplicationUsersListComponent,
    HeaderComponent,
    ApplicationUsersDetailComponent,
    SdsSearchComponent,
    LoginReportsComponent,
    DownloadReportsComponent,
    SearchSdsReportsComponent
  ],
  imports: [InputTextModule,
    TooltipModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    CalendarModule,
    // AngularFireModule.initializeApp(environment.firebaseConfig),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAppCheck(() => initializeAppCheck(getApp(), {
        provider: new ReCaptchaEnterpriseProvider(environment.recaptchaSiteKey),
      })),   
    AngularFireAuthModule,
    PopoverModule,
    BrowserAnimationsModule,
    TableModule,
    ButtonModule,
    AccordionModule,
    DialogModule,
    HttpClientModule,
    SidebarModule ,
    MenuModule ,
    PanelMenuModule ,
    OverlayPanelModule ,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MessagesModule,NotifierModule.withConfig({
      position: {
        horizontal: {
          position: 'right',
        },
        vertical: {
          position: 'top',
        },
      },
      behaviour: {
        autoHide: 3000,
        showDismissButton: true,
      },
    }),
  ],
  providers: [AuthGuard,ApplicationUserService,DatePipe,
    { provide: FIREBASE_OPTIONS, useValue: environment.firebaseConfig },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true 
    },
    provideUserIdleConfig({ idle: 600, timeout: 300, ping: 120 })
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
